import { extend } from 'flarum/common/extend';
import { headerFlag } from '../../common/helpers/headerFlag';

/**
 * The sender's flag in a private message's header (flarum/messages), on the
 * same terms as a post's — see headerFlag().
 */
export default function extendMessage() {
  extend('ext:flarum/messages/forum/components/Message', 'headerItems', function (items) {
    const message = this.attrs.message;
    const flag = headerFlag(message.user(), message.ipInfo?.());
    if (flag) items.add('country', flag, 100);
  });
}
flarum.reg.add('fof-geoip', 'forum/extenders/extendMessage', extendMessage);